import React from 'react';
import { formatCurrency } from '../../utils/commonUtils';
import { StatisticsTable } from './StatisticsTable';
import { StatisticsChart } from './StatisticsChart';

interface TopUser {
  user_id: number;
  user_name: string;
  user_surname: string;
  management: string;
  office: string;
  order_count: number;
  total_spent: number;
  average_order_amount: number;
}

interface UserStatsByDepartment {
  management: string;
  user_count: number;
  total_orders: number;
  total_spent: number;
  average_orders_per_user: number;
  average_spent_per_user: number;
}

interface UserStatsByOffice {
  office: string;
  management: string;
  user_count: number;
  total_orders: number;
  total_spent: number;
  average_orders_per_user: number;
  average_spent_per_user: number;
}

interface MostActiveUser {
  user_id: number;
  user_name: string;
  user_surname: string;
  management: string;
  office: string;
  recent_orders: number;
  recent_spent: number;
  last_order_date: string;
}

interface UserStatisticsSectionProps {
  topUsersByOrders: TopUser[];
  topUsersBySpent: TopUser[];
  userStatsByDepartment: UserStatsByDepartment[];
  userStatsByOffice: UserStatsByOffice[];
  mostActiveUsers: MostActiveUser[];
}

const UserStatisticsSection: React.FC<UserStatisticsSectionProps> = ({
  topUsersByOrders,
  topUsersBySpent,
  userStatsByDepartment,
  userStatsByOffice,
  mostActiveUsers,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
    {/* En Çok Sipariş Veren Kullanıcılar */}
    <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
      <h3 className="font-bold text-lg mb-4 text-gray-800">En Çok Sipariş Verenler</h3>
      <div className="flex-1 overflow-auto">
        <StatisticsTable
          columns={[
            { key: 'user_name', label: 'Ad' },
            { key: 'user_surname', label: 'Soyad' },
            { key: 'management', label: 'Departman' },
            { key: 'office', label: 'Büro' },
            { key: 'order_count', label: 'Sipariş Sayısı' },
            { key: 'total_spent', label: 'Toplam Harcama', render: row => formatCurrency(row.total_spent) },
          ]}
          data={topUsersByOrders}
        />
      </div>
    </div>
    
    <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
      <h3 className="font-bold text-lg mb-4 text-gray-800">En Çok Sipariş Verenler (Bar Chart)</h3>
      <div className="flex-1 flex items-center justify-center min-h-0 w-full overflow-hidden">
        <StatisticsChart
          type="bar"
          data={topUsersByOrders}
          dataKey="order_count"
          xKey="user_name"
          title=""
          color="#6366f1"
          height={260}
        />
      </div>
    </div>
    
    {/* En Çok Harcama Yapan Kullanıcılar */}
    <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
      <h3 className="font-bold text-lg mb-4 text-gray-800">En Çok Harcama Yapanlar</h3>
      <div className="flex-1 overflow-auto">
        <StatisticsTable
          columns={[
            { key: 'user_name', label: 'Ad' },
            { key: 'user_surname', label: 'Soyad' },
            { key: 'management', label: 'Departman' },
            { key: 'office', label: 'Büro' },
            { key: 'total_spent', label: 'Toplam Harcama', render: row => formatCurrency(row.total_spent) },
            { key: 'order_count', label: 'Sipariş Sayısı' },
          ]}
          data={topUsersBySpent}
        />
      </div>
    </div>
    
    <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
      <h3 className="font-bold text-lg mb-4 text-gray-800">En Çok Harcama Yapanlar (Bar Chart)</h3>
      <div className="flex-1 flex items-center justify-center min-h-0 w-full overflow-hidden">
        <StatisticsChart
          type="bar"
          data={topUsersBySpent}
          dataKey="total_spent"
          xKey="user_name"
          title=""
          color="#10b981"
          height={260}
        />
      </div>
    </div>
    
    {/* Departman İstatistikleri */}
    <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
      <h3 className="font-bold text-lg mb-4 text-gray-800">Departmanlara Göre Sipariş</h3>
      <div className="flex-1 overflow-auto">
        <StatisticsTable
          columns={[
            { key: 'management', label: 'Departman' },
            { key: 'user_count', label: 'Kullanıcı Sayısı' },
            { key: 'total_orders', label: 'Toplam Sipariş' },
            { key: 'total_spent', label: 'Toplam Harcama', render: row => formatCurrency(row.total_spent) },
          ]}
          data={userStatsByDepartment}
        />
      </div>
    </div>
    
    <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col h-[370px]">
      <h3 className="font-bold text-lg mb-4 text-gray-800">Departmanlara Göre Sipariş Dağılımı</h3>
      <div className="flex-1 flex items-center justify-center min-h-0 w-full overflow-hidden">
        <StatisticsChart
          type="pie"
          data={userStatsByDepartment}
          dataKey="total_orders"
          nameKey="management"
          title=""
          height={260}
        />
      </div>
    </div>
  </div>
);

export default UserStatisticsSection; 